// Device Hardware Type Map

export const HARDWARE_TYPE_MAP = {
  1: "DEM 2O1A",
  2: "DEM 8O2A",
  3: "DEM 8O1A",
  11: "DEM 4O1A",
  16: "Air2One",
  17: "Air2Two",
  18: "Air2Four",
  23: "Air2Four (LAN)",
  19: "Data Logger",
  20: "Air2Mini",
  21: "Air2Mini (All RFID Types)",
  22: "BatteryPack",
  24: "Air2Mini (External Speaker)",
};

// Settings Map

export const SETTINGS_TYPE_MAP = [
  { addr: 72, bit_pos: 0, name: "Opening Time" },
  { addr: 164, bit_pos: 4, name: "Open Door Warning" },
  { addr: 136, bit_pos: 0, mult: 5, name: "Open Door Warning Timeout" },
  { addr: 122, bit_pos: 1, name: "Watchmaker Mode" },
  { addr: 155, bit_pos: 0, name: "Validation Mode" },
  { addr: 125, bit_pos: 0, name: "Security Mode", hasConnectionMode: true },
  { addr: 139, bit_pos: 0, name: "One Door Only", hasConnectionMode: true },

  { addr: 186, bit_pos: 32, name: "Memo Sounds" },
  { addr: 186, bit_pos: 64, name: "Soft Door Open Warning" },
  { addr: 189, bit_pos: 0, name: "Volume" },

  { addr: 164, bit_pos: 2, name: "Intrusion Alarm" },
  { addr: 104, bit_pos: 0, name: "2-Way Authentication" },
  { addr: 88, bit_pos: 0, name: "Opening Delay" },
];

export const EXPIRING_SOON_HOURS = 48;

// Alert filter time limits (notifications)

export const ALERT_MIN_ACTIVE_HOURS = 0.5;
export const ALERT_EXPIRES_MAX_HOURS = 48;
export const ALERT_ALL_MAX_HOURS = 48;

export const WANTED_SETTING_NAMES = [
  "Intrusion Alarm",
  "Opening Delay",
  "Security Mode",
  "2-Way Authentication",
  "Enhanced Sound Set",
];


export const INDEFINITE_SETTINGS_CONFIG = {
  // Brand: Bucherer, Shop: Bucherer, Country: Germany, City: Munich
  "1770025821253_Rrlyiwe25wbMTaCA8kAP0TXPW07aWa64avqflxBqpS18MZVFquhgfXUSJI4dLaCGrJjSuMh83TdKubqkGkLhG6TLYJjENJHdKPuSORClvkU0rlmHZQ+fgA5aeKCaUHZr":
    "all",

  // Brand: Bucherer, Shop: Stuttgart, Country: Germany, City: Stuttgart
  "1773154965825_W89iyELDet3qoqg5fZPALrYpXjc.TzCITcaTts.qTlUgPi9B.yFgMhufq+BfaEmFJ+aF72wU7Nfw0AoNGa.dGnGBURnU7RmmKq1N04M8XoIEZEBspESdYyzKIuEnPQ5q":
    "all",

  // Brand: Bucherer, Shop: Bucherer Kaiserstr, Country: Germany, City: Frankfurt
  "1742889408008_lYb2lJwXKWP3UdSQF1o+tsXqRXK229NCVYU90gRKoWF8Eu2WVRCVe.kyqtbQMS5HZsAfCHZBifoKkoULw54mTqlSUki3Py1m2u6MiQZaLeHPGt.c1aiJQFWkyRxvGmSF": [
    "84:FC:E6:4B:B2:F8",
    "84:FC:E6:4B:C7:D8",
    "84:FC:E6:4B:D9:28",
    "84:FC:E6:4B:D9:48",
  ],
// test Carol
  "1784012362188_NQ78tdNgW1bZ50p62WMqMIHg9En0GJMrW4nKOV82Jrb4eT0lPzroBvEQM5RwPRmKJ9v7BPmgMI0k8UesPjIVYpHghNtbXR8DUIdSQhmnz4QeU9F43f0BQ6C4PB6Aaxd7":
    ["84:FC:E6:4B:D8:68"]

};


export const WANTED_SETTINGS = SETTINGS_TYPE_MAP.filter(({ name }) =>
  WANTED_SETTING_NAMES.includes(name),
);

export const GET_DOOR_SETTING_ADDRESS = (settingType, doorNumber) => {
  const doorIndex = doorNumber - 1;

  switch (settingType.name) {
    case "Opening Time":
    case "2-Way Authentication":
    case "Opening Delay":
      return {
        addr: settingType.addr + doorIndex,
        bit_pos: settingType.bit_pos,
      };

    case "Watchmaker Mode":
      return {
        addr: settingType.addr,
        bit_pos: settingType.bit_pos << doorIndex,
      };

    default:
      return {
        addr: settingType.addr,
        bit_pos: settingType.bit_pos,
      };
  }
};

// Door Detect
// { addr: 140, bit_pos: 1, name: "Door Detect" }, // 0x8C, 0x01

export const INTRUSION_INPUT_MAP = {
  1: { addr: 140, bit_pos: 1 }, // { addr: 140, bit_pos: 1, name: "Door 1 Detect" }, // 0x8C, 0x01
  2: { addr: 140, bit_pos: 4 }, // { addr: 140, bit_pos: 4, name: "Door 2 Detect" }, // 0x8C, 0x04
  3: { addr: 140, bit_pos: 16 }, // { addr: 140, bit_pos: 16, name: "Door 3 Detect" }, // 0x8C, 0x10
  4: { addr: 140, bit_pos: 64 }, // { addr: 140, bit_pos: 64, name: "Door 4 Detect" }, // 0x8C, 0x40

  5: { addr: 141, bit_pos: 1 }, // { addr: 141, bit_pos: 1, name: "Door 5 Detect" }, // 0x8D, 0x01
  6: { addr: 141, bit_pos: 4 }, // { addr: 141, bit_pos: 4, name: "Door 6 Detect" }, // 0x8D, 0x04
  7: { addr: 141, bit_pos: 16 }, // { addr: 141, bit_pos: 16, name: "Door 7 Detect" }, // 0x8D, 0x10
  8: { addr: 141, bit_pos: 64 }, // { addr: 141, bit_pos: 64, name: "Door 8 Detect" }, // 0x8D, 0x40
};

export const HARDWARE_DOOR_COUNT_MAP = {
  1: 2, // DEM 2O1A
  2: 8, // DEM 8O2A
  3: 8, // DEM 8O1A
  11: 4, // DEM 4O1A

  16: 1, // Air2One
  17: 2, // Air2Two
  18: 4, // Air2Four
  23: 4, // Air2Four (LAN)

  19: 0, // Data Logger
  20: 1, // Air2Mini
  21: 1, // Air2Mini (All RFID Types)
  22: 0, // BatteryPack
  24: 1, // Air2Mini (External Speaker)
};

export const DOOR_MASKS = {
  4: {
    1: 16, // Door 1 -> bit 4 (0x10)
    2: 32, // Door 2 -> bit 5 (0x20)
    3: 64, // Door 3 -> bit 6 (0x40)
    4: 128, // Door 4 -> bit 7 (0x80)
  },

  8: {
    1: 1, // Door 1 -> bit 0 (0x01)
    2: 2, // Door 2 -> bit 1 (0x02)
    3: 4, // Door 3 -> bit 2 (0x04)
    4: 8, // Door 4 -> bit 3 (0x08)
    5: 16, // Door 5 -> bit 4 (0x10)
    6: 32, // Door 6 -> bit 5 (0x20)
    7: 64, // Door 7 -> bit 6 (0x40)
    8: 128, // Door 8 -> bit 7 (0x80)
  },
};

// Log type IDs

export const LOG_TYPES = {
  validPin: 1,
  validKey: 2,
  invalidPin: 8,
  invalidKey: 9,
  intrusion: 48,
  oneDoorOnly: 49,
  openDoorWarning: 50,
  doorEvent: 51,
  deviceActivation: 144,
  settingChange: 157,
  deviceReboot: 158,
};

// Log type messages returned by the Device Logs API.

export const LOG_TYPE_MESSAGES = {
  // Transactions
  1: "PIN accepted ",
  2: "Keycard accepted ",
  3: "Special function PIN ",
  4: "Special function keycard accepted ",
  8: "Invalid PIN ",
  9: "Invalid keycard ",
  10: "Invalid lock for PIN ",
  11: "Invalid lock for keycard ",
  12: "Controller time not updated. ",
  13: "Keycard expired. ",
  15: "2-Way-Authorization activated. ",

  // Programming
  16: "Access PIN programmed ",
  17: "Access keycard programmed ",
  18: "Special function PIN programmed ",
  19: "Special function card programmed ",
  20: "Key management card programmed ",
  24: "ID-memory full - PIN programming refused ",
  25: "ID-memory full - Chip key programming refused ",

  // ID memory
  32: "1 PIN for single lock erased ",
  33: "1 chip key for single lock erased ",
  34: "1 PIN for all locks erased",
  35: "1 chip key for all locks erased",
  36: "All IDs for 1 lock erased",
  37: "ID-memory entry erased by index",
  38: "Entire ID-memory erased",

  // Switching-unit security
  48: "Intrusion Alarm ",
  49: "1-Door Only Alarm ",
  50: "Open Door Warning ",
  51: "Door Event ",
  52: "Alarm Input ",

  // Alarm-unit security
  64: "Intrusion alarm ",
  65: "Silent alarm ",
  66: "Sabotage alarm ",
  67: "Bus configuration error ",
  68: "Any door open alarm ",
  69: "Door open warning alarm ",
  70: "Bus blocking alarm ",
  71: "Deco-mode enable ",
  72: "Deco mode ",

  // Bootup
  80: "New event-log started",
  81: "Keypad orientation detected",
  82: "RTC set during 1st bootup",
  83: "Number of mastercards stored",
  84: "Mastercard stored",
  86: "Device S/N stored",
  87: "Max. number of locks stored",
  88: "Configuration data changed during 1st bootup",
  89: "Program card stored",
  94: "1st bootup successful",
  95: "Normal bootup ok",

  // Hardware tests
  96: "Lock test finished",
  97: "Sensor test finished",
  98: "Hand terminal test finished",
  99: "Alarm test finished",
  100: "Rotary switch test finished",
  103: "Bus load display",
  104: "Keycard reported",

  // System administration
  112: "RTC set by user",
  113: "Configuration data changed by user",
  114: "ID memory dumped",
  115: "Event-log erased & new event-log started by user",
  116: "Event log dumped",
  117: "System card erased",
  118: "System card programmed",
  119: "Set configuration defaults",
  120: "HIF PIN altered",
  121: "Application unlocked",
  122: "Application locked",

  // Errors
  128: "Clock forced to Sun, 2012-01-01 00:00:00",
  129: "Log flash write address invalid",

  // Device Logging Server
  146: "New device activated by user",
  148: "Key added to user",
  150: "Start programming mode",
  151: "Key erased successfully",
  157: "Setting change success",
  158: "Device reboot",
  159: "Security feature",
};

// Months

export const MONTHS = [
  { value: "", label: "All Months" },
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

// Controller status

export const CONTROLLER_ONLINE_TIMEOUT_MS = 30 * 60 * 1000;

export const GET_CONTROLLER_STATUS = (controller) => {
  const rawCloudStatus =
    controller?.device_info?.cloud_status ??
    controller?.cloud_status ??
    controller?.status ??
    controller?.device_status ??
    controller?.connectionStatus ??
    controller?.connection_status;

  const rawLastUpdated =
    controller?.last_updated ??
    controller?.lastUpdated ??
    controller?.device_info?.last_updated;

  const normalizedCloudStatus = String(rawCloudStatus ?? "")
    .trim()
    .toLowerCase();

  const cloudIsOnline =
    rawCloudStatus === true ||
    rawCloudStatus === 1 ||
    normalizedCloudStatus === "1" ||
    normalizedCloudStatus === "online" ||
    normalizedCloudStatus === "connected" ||
    normalizedCloudStatus === "active";

  const lastUpdatedNumber = Number(rawLastUpdated);

  // Convert Unix timestamp in seconds to milliseconds when necessary.
  const lastUpdatedMilliseconds =
    lastUpdatedNumber > 0 && lastUpdatedNumber < 100000000000
      ? lastUpdatedNumber * 1000
      : lastUpdatedNumber;

  const timeSinceLastUpdate = Date.now() - lastUpdatedMilliseconds;

  const hasRecentUpdate =
    Number.isFinite(lastUpdatedMilliseconds) &&
    timeSinceLastUpdate >= 0 &&
    timeSinceLastUpdate <= CONTROLLER_ONLINE_TIMEOUT_MS;

  return cloudIsOnline && hasRecentUpdate ? "Online" : "Offline";
};